export type ScrollPopupConfig = {
  titleText: string;
  subtitleText: string;
  phonePlaceholder: string;
  submitButtonText: string;
  termsText: string;
  termsUrl: string;
};

export const defaultScrollPopupConfig: ScrollPopupConfig = {
  titleText: "Apply for a Credit Card",
  subtitleText: "Get up to AED 1500 Welcome Bonus.",
  phonePlaceholder: "Enter Mobile no.",
  submitButtonText: "Submit",
  termsText: "*T&C apply",
  termsUrl: "/scroll-popup-terms",
};
